module.exports = __webpack_public_path__ + "db5fb5d254951aa94d01aae6d422f171.svg";